import { Redirect } from '@shared/model/types'

const parseUrl = (fullPath: string, req:any, redirect: Redirect) => {
  if (fullPath.includes('%3A%2B')) {
    const currentUrl = fullPath
    const url = currentUrl.replace(/%3A%2B/ig, '=').replace(/%2B/ig, '&').replace(/%3F/ig, '&')

    const protocol = req.headers['x-forwarded-proto'] || 'http'
    const host = req.headers.host

    const newUrl = `${protocol}://${host}${url}`

    redirect(302, newUrl)
  }
}

export default parseUrl
